import { Skeleton } from '@shared/components/ui/shadcn';
import React from 'react';

/**
 * Componente PackCardSkeleton - Muestra skeleton para la tarjeta de pack
 * 
 * Este componente replica la estructura de PackCard pero con skeletons
 * para mostrar un estado de carga mientras se obtienen los datos.
 */
export const PackCardSkeleton = React.memo(() => {
  return (
    <div
      className="dark:bg-card-bg border border-card-border rounded-xl p-4 bg-body-bg"
      data-testid="pack-card-skeleton"
    >
      {/* Header del pack - Skeleton del header */}
      <div className="flex justify-between items-start mb-4">
        {/* Título - Skeleton del título */}
        <div className="flex-1 min-w-0">
          <Skeleton className="h-5 w-3/4 bg-hover-press" />
        </div>
        {/* Dropdown Actions - Skeleton del menú de opciones */}
        <div className="ml-2 flex-shrink-0">
          <Skeleton className="w-6 h-6 rounded bg-hover-press" />
        </div>
      </div>

      {/* Contenido - Skeleton del contenido */}
      <div className="space-y-2 mt-2">
        {/* Productos - Skeleton de productos */}
        <div className="flex items-center text-sm">
          {/* Icono - Skeleton del icono (size="lg" en FontAwesome) */}
          <Skeleton className="w-5 h-5 rounded mr-2 bg-hover-press" />
          {/* Texto "Productos" - Skeleton del texto */}
          <Skeleton className="h-4 w-20 mr-2 bg-hover-press" />
          {/* Badge con número - Skeleton del badge */}
          <Skeleton className="h-6 w-12 rounded-full bg-hover-press" />
        </div>
      </div>
    </div>
  );
});

PackCardSkeleton.displayName = 'PackCardSkeleton';

export default PackCardSkeleton;

